import { render, staticRenderFns } from "./detainmentDialog.vue?vue&type=template&id=5c194228&scoped=true"
import script from "./detainmentDialog.vue?vue&type=script&lang=js"
export * from "./detainmentDialog.vue?vue&type=script&lang=js"
import style0 from "./detainmentDialog.vue?vue&type=style&index=0&id=5c194228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c194228",
  null
  
)

export default component.exports